import React from "react"
import { adjustPlan } from "../../api/plans"
import Button from "../Button"
import { toast } from "react-toastify"

export default props => {
    const [loading, setLoading] = React.useState(false)

    async function tryAdjustPlan() {
        setLoading(true)
        adjustPlan().then(result => {
            if (result.updated) {
                toast.success("Assinatura atualizada!")
            } else {
                toast.error(result.message || "Não foi possível atualizar!")
            }
            setTimeout(() => {
                window.location.reload()
            }, 3000)
        }).catch(() => {
            setLoading(false)
            toast.error("Ocorreu um erro ao tentar atualizar.")
        })
    }
    
    return (
        <div className={props.className} style={props.style}>
            {props.variant === "modern" ? (
                <div
                    onClick={loading ? undefined : tryAdjustPlan}
                    className="d-flex align-items-center justify-content-between w-100"
                    style={{ cursor: loading ? "wait" : "pointer", padding: "16px 0" }}
                >
                    <div className="d-flex align-items-center">
                        <i className={`fas fa-sync-alt mr-3 ${loading ? "fa-spin" : ""}`} style={{ color: "#0056b3", fontSize: "20px" }}></i>
                        <span style={{ color: "#0056b3", fontWeight: "600", fontSize: "16px" }}>Recarregar os Dados do Plano</span>
                    </div>
                    <i className="fas fa-chevron-right" style={{ color: "#000" }}></i>
                </div>
            ) : (
                <div className="d-flex flex-column align-items-center">
                    <Button
                        as="text"
                        title="Ajustar Assinatura"
                        text
                        disabled={loading}
                        loading={loading}
                        onClick={tryAdjustPlan}>
                        Recarregar os Dados do Plano
                    </Button>
                    {props.helperText && (
                        <small className="text-muted mt-1 text-center" style={{ fontSize: "0.8rem", maxWidth: "250px" }}>
                            {props.helperText}
                        </small>
                    )}
                </div>
            )}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/_components/ReloadPlanDataButton/index.jsx